import { render, staticRenderFns } from "./archivoTemplate.vue?vue&type=template&id=0195672d&"
import script from "./archivoTemplate.vue?vue&type=script&lang=js&"
export * from "./archivoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports